import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { SetPinType, ChangeLimitRequest } from 'src/app/models/account';
import { InputPinComponent } from 'src/app/pin-limit/shared/input-pin/input-pin.component';

declare var $: any;

@Component({
  selector: 'app-input-limit',
  templateUrl: './input-limit.component.html',
  styleUrls: ['./input-limit.component.css']
})
export class InputLimitComponent implements OnInit {
  @Input() isChange: boolean;
  @Output() changeLimit: EventEmitter<ChangeLimitRequest> = new EventEmitter<ChangeLimitRequest>();
  @Output() setLimit: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('limitEl') limitField: ElementRef;
  @ViewChild(InputPinComponent) inputPin: InputPinComponent;
  dataLimit: ChangeLimitRequest = new ChangeLimitRequest();
  limit = '';
  isOn = false;
  pin = '';

  constructor(private authService: AuthenticationService) { }

  get getPinStep() { return SetPinType; }

  ngOnInit() {
    this.applyJqueryScript();
    this.loadlimit();

    this.limitField.nativeElement.focus();
  }

  applyJqueryScript(): void {
    const that = this;
    $(document).ready(function () {
      $('#toggle-one').bootstrapToggle();
      $('#toggle-one').prop('checked', that.isOn).change();
    });

    $('#toggle-one').on('change', function () {
      if ($(this).is(':checked')) {
        that.isOn = true;
      } else {
        that.isOn = false;
      }
    });
  }

  loadlimit() {
    this.authService.getLimit(
      resp => {
        if (resp.alert.code === 200) {
          this.limit = resp.data.limit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          this.isOn = resp.data.isOn;

          this.applyJqueryScript();
        } else {
          console.log(resp);
        }
      },
      err => {
        console.log(err);
      });
  }

  filterNumeric() {
    this.limit = this.limit.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  next(isValid: boolean) {
    if (isValid) {
      if (this.isChange) {
        $('#askPin').modal('show');
      } else {
        this.limit = this.limit.replace(/\./g, '');
        this.setLimit.emit(Number.parseInt(this.limit));
      }
    }
  }

  setPin(pin: string) {
    this.pin = pin;
    this.limit = this.limit.replace(/\./g, '');

    this.dataLimit.limit = Number.parseInt(this.limit);
    this.dataLimit.isOn = this.isOn;
    this.dataLimit.pin = pin;

    this.changeLimit.emit(this.dataLimit);

    $('#askPin').modal('hide');
  }
}
